import { render, staticRenderFns } from "./TicketIssueDocument.vue?vue&type=template&id=5fa009f6&scoped=true&"
import script from "./TicketIssueDocument.vue?vue&type=script&lang=js&"
export * from "./TicketIssueDocument.vue?vue&type=script&lang=js&"
import style0 from "./TicketIssueDocument.vue?vue&type=style&index=0&id=5fa009f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa009f6",
  null
  
)

export default component.exports